import component from './ctr.vue'

export default component
